import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "AlignRight.svg",
  "use": "AlignRight.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"AlignRight.svg\"><path d=\"M50.0208,50.0208h-24a2,2,0,0,1,0-4h24a2,2,0,0,1,0,4Zm0-8h-36a2,2,0,0,1,0-4h36a2,2,0,0,1,0,4Zm0-8h-34a2,2,0,1,1,0-4h34a2,2,0,1,1,0,4Zm0-8h-28a2,2,0,1,1,0-4h28a2,2,0,1,1,0,4Zm0-8h-36a2,2,0,1,1,0-4h36a2,2,0,1,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol